// Общие помощники «Поделиться презентацией»

export const MB = 1024 * 1024;

export const TYPE_LABELS = { pdf: 'PDF', pptx: 'PowerPoint', odp: 'OpenDocument' };

export function formatSize(bytes) {
    if (!bytes && bytes !== 0) return '';
    if (bytes < MB) return `${Math.max(1, Math.round(bytes / 1024))} КБ`;
    return `${(bytes / MB).toFixed(1).replace('.', ',')} МБ`;
}

export function formatDate(value) {
    if (!value) return '';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

export function daysWord(n) {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return 'день';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'дня';
    return 'дней';
}

export function shareUrl(kind, ref) {
    return `${window.location.origin}/share/${kind}/${ref}`;
}

// Участник только что ответил на опрос: показать ему карточку на странице результатов (а проектору — нет)
const justVotedKey = (ref) => `svod_share_after_vote_${ref}`;

export function markJustVoted(ref) {
    try { sessionStorage.setItem(justVotedKey(ref), '1'); } catch { /* без sessionStorage карточки просто не будет */ }
}

export function isJustVoted(ref) {
    try { return sessionStorage.getItem(justVotedKey(ref)) === '1'; } catch { return false; }
}

// Почту уже оставили или отказались — запоминаем в этой вкладке, чтобы не предлагать снова
const stateKey = (kind, ref) => `svod_share_${kind}_${ref}`;

export function loadShareState(kind, ref) {
    try { return JSON.parse(sessionStorage.getItem(stateKey(kind, ref)) || 'null'); } catch { return null; }
}

export function saveShareState(kind, ref, value) {
    try { sessionStorage.setItem(stateKey(kind, ref), JSON.stringify(value)); } catch { /* не критично */ }
}

export const FileIcon = () => (
    <svg className="share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" /><path d="M14 3v5h5M12 12v6M9 15l3 3 3-3" />
    </svg>
);
